"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateEventForSchema = void 0;
var _exceptions = require("./exceptions");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var validateEventForSchema = function validateEventForSchema(event, schema, type) {
  var invalidPaths = [];
  type.isValid(event, {
    errorHook: function errorHook(path, any) {
      invalidPaths.push({
        fieldName: path.join(),
        receivedValue: any
      });
    }
  });
  if (invalidPaths.length) {
    var invalidPathsWithDetails = invalidPaths.map(function (_ref) {
      var fieldName = _ref.fieldName,
        receivedValue = _ref.receivedValue;
      return "- \"".concat(fieldName, "\" cannot be of type \"").concat(_typeof(receivedValue), "\" (received: ").concat(receivedValue, ")");
    });
    throw new _exceptions.InvalidEventForSchemaException(schema.name, invalidPaths.length, invalidPathsWithDetails);
  }
};
exports.validateEventForSchema = validateEventForSchema;